import { render, staticRenderFns } from "./StatisticsReport.vue?vue&type=template&id=f028d86a&"
import script from "./StatisticsReport.vue?vue&type=script&lang=js&"
export * from "./StatisticsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports